module.exports = {
          srcSet: "/_next/static/images/img-voitures@2x-200-f9d6aaadee8189f9719166263b30c283.jpg"+" 200w",
          images:[ {path: "/_next/static/images/img-voitures@2x-200-f9d6aaadee8189f9719166263b30c283.jpg",width: 200,height: 171}],
          src: "/_next/static/images/img-voitures@2x-200-f9d6aaadee8189f9719166263b30c283.jpg",
          toString:function(){return "/_next/static/images/img-voitures@2x-200-f9d6aaadee8189f9719166263b30c283.jpg"},
          placeholder: undefined,
          width: 200,
          height: 171
      }